import pipeline from '@jetbrains/icons/pipeline'
import Icon from '@jetbrains/ring-ui-built/components/icon/icon'
import Tag, {TagType} from '@jetbrains/ring-ui-built/components/tag/tag'

import {isEarlyAccessLabelEnabled} from '../../../../utils/featureToggles'
import DisabledButtonHint from '../../DisabledButtonHint/DisabledButtonHint'
import parentStyles from '../CreateEntityButton.module.css'

type Props = {
  disabled?: boolean
  disabledReason?: string
}

export default function CreatePipelineMenuItem({disabled, disabledReason}: Props) {
  return (
    <DisabledButtonHint disabled={disabled} reason={disabledReason}>
      <Icon className={parentStyles.icon} glyph={pipeline} />
      {'New pipeline'}
      {isEarlyAccessLabelEnabled && (
        <Tag
          readOnly
          tagType={TagType.SUCCESS}
          interactive={false}
          containerClassName={parentStyles.earlyAccessTag}
        >
          {'Early access'}
        </Tag>
      )}
    </DisabledButtonHint>
  )
}
